import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

export const PlaylistCardShimmer = () => {
  return (
    <div
      className="relative mb-3 mx-auto bg-white rounded-lg overflow-hidden"
      style={{
        boxShadow:
          '0px 2px 1px rgba(0, 0, 0, .05), 0px 0px 1px rgba(0, 0, 0, .25)', // wait until token is updated
      }}
    >
      <div className="p-4">
        <div className="mb-4 my-1">
          <Shimmer
            height={20}
            noOfLines={1}
            className="w-full"
            style={{ width: '75%' }}
          />
        </div>
        <div className="mb-2">
          <Shimmer
            height={16}
            noOfLines={3}
            className="w-full mb-3"
            style={{ width: '100%' }}
          />
        </div>
        <div className="flex items-center w-full">
          <Shimmer width={24} height={24} rounded />
          <Shimmer
            height={16}
            noOfLines={1}
            className="ml-2"
            style={{ width: '50%' }}
          />
        </div>
      </div>
      {/*Card Body*/}
    </div>
  )
}

export const VideoDescriptionShimmer = () => (
  <div>
    <Shimmer height={16} width={205} className="mb-3" />
    <Shimmer height={16} className="mb-1" style={{ width: '100%' }} />
    <Shimmer
      height={16}
      className="mb-4"
      style={{ width: 'calc(100% - 25px)' }}
    />
    <Shimmer height={16} width={205} />
  </div>
)

export const VideoCountShimmer = () => (
  <Shimmer height={16} width={60} className="mb-4" />
)

export const VideoCardShimmer = () => {
  return (
    <div className="relative flex mb-4 last:mb-0 w-full">
      <div className="flex-shrink-0 flex-grow-0 relative">
        <Shimmer
          height={64}
          noOfLines={1}
          className="rounded-lg"
          style={{ width: '118px' }}
        />
      </div>
      <div className="ml-[5px] flex-grow">
        <Shimmer
          height={16}
          noOfLines={1}
          className="mb-1"
          style={{ width: '100%' }}
        />
        <Shimmer
          height={16}
          noOfLines={1}
          className="mb-3"
          style={{ width: 'calc(100% - 25px)' }}
        />
        <Shimmer
          height={16}
          noOfLines={1}
          className="block"
          style={{ width: '64px' }}
        />
      </div>
    </div>
  )
}

export const VideoShimmer = () => {
  return (
    <div>
      <div className="w-full pt-[56px]">
        <div className="yt-ratio-wrapper">
          <Shimmer
            noOfLines={1}
            className="shimmer w-full rounded-lg"
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      </div>
      <div className="p-4">
        <Shimmer
          height={16}
          noOfLines={1}
          className="shimmer mb-1 w-full"
          style={{ width: '100%' }}
        />
        <Shimmer
          height={16}
          noOfLines={1}
          className="shimmer mb-1 w-full"
          style={{ width: '100%' }}
        />
        <Shimmer
          height={16}
          noOfLines={1}
          className="shimmer mb-1 w-full"
          style={{ width: '100%' }}
        />
      </div>
    </div>
  )
}
